export default {
    url: 'powerforall',
    include: ['us', 'ca', 'de', 'fr', 'it', 'es', 'cn', 'za', 'au', 'eu', 'uk'],
};
